<template>
	<div class="flex flex-grow h-full justify-end bg-white rounded-lg sticky" style="align-self: end">
		<div class="w-full h-full border-4 rounded-lg shadow" style="border-color: #0068B4;">
			<div class="flex text-white pt-2 pb-2 bg-connectProBlue" style="width: 370px; min-height: 45px; max-width: 370px; max-height: 370px;">
				<div class="flex flex-grow font-bold justify-start ml-4">{{ $t('chat') }}</div>
				<div
					class="mr-4 cursor-pointer"
					@click="$router.push({ name: 'repair_shop.chats_detail', params: { id: chat.id } })"
					v-if="this.messages.length > 0"
				>
					<font-awesome-icon :icon="['fas', 'expand']" class="text-white" />
				</div>
				<div class="mr-4 cursor-pointer" @click="triggerState">
					<font-awesome-icon :icon="['fas', 'times']" class="text-white" />
				</div>
			</div>
			<div class="justify-between" style="max-width: 370px;">
				<div class="flex">
					<div class="overscroll-none" style="overflow: auto;" ref="scrollablelist">
						<div style="height: 350px; width: 370px" v-if="!isInitialLoading">
							<div class="pr-4 pl-4 justify-start" ref="messagesRef">
								<div
									v-for="(message, index) in this.messages"
									:key="message.id"
									class="flex flex-row mt-3"
									:class="index === messages.length - 1 ? 'pb-5' : ''"
									:ref="`element${message.id}`"
								>
									<div
										v-if="message.sender_type === 'App\\User'"
										class="grid grid-flow-col flex-shrink flex-row gap-3 justify-center"
										style="align-items: center"
									>
										<img
											alt="IMD Logo"
											:src="profileImage(chat.company.image)"
											class="rounded-full object-contain justify-center"
											style="align-content: center; text-align: center; width: 35px; height: 35px; object-fit: cover; background: #e4e5e4;"
										/>
										<div class="flex text-wrap align-middle bg-connectProBlue text-white justify-center rounded shadow pb-1 pt-1 pl-4 pr-4">
											<div>
												<div class="flex flex-row">
													<div class="flex justify-start pr-1" style="font-size: 13px; align-content: end">
														{{ message.sender.first_name + ' ' + message.sender.last_name }}
													</div>
													<div class="flex justify-start" style="font-size: 13px; align-content: end">
														{{ getGermanDateTime(message.created_at) }}
													</div>
												</div>
												<div v-if="message.content !== ''" style="text-align: start">
													{{ message.content }}
												</div>
											</div>
										</div>
									</div>
									<div v-else class="grid grid-flow-col flex-shrink flex-row gap-3 justify-start" style="align-items: center">
										<img
											alt="IMD Logo"
											:src="profileImage(chat.customer.image)"
											class="flex rounded-full object-contain justify-center"
											style="align-content: center; text-align: center; width: 35px; height: 35px; object-fit: cover; background: #e4e5e4;"
										/>
										<div class="flex text-wrap align-middle bg-gray-300 text-black justify-center rounded shadow pb-1 pt-1 pl-4 pr-4">
											<div class="flex flex-col">
												<div class="flex flex-row">
													<div class="flex justify-start pr-1" style="font-size: 13px; align-content: end">
														{{
															message.sender.company_name != null
																? message.sender.company_name
																: message.sender.first_name + ' ' + message.sender.last_name
														}}
													</div>
													<div class="flex justify-start" style="font-size: 13px; align-content: end">
														{{ getGermanDateTime(message.created_at) }}
													</div>
												</div>
												<div class="flex" v-if="message.content !== ''" style="text-align: start; white-space: pre-line">
													{{ message.content }}
												</div>
												<div v-if="message.type === 'image'" class="mb-2">
													<BaseImage
														alt="Chat image"
														:src="message.file.base64content"
														:show-big="true"
														class="flex flex-shrink object-contain justify-center mt-2"
														style="align-content: center; text-align: center; width: 260px; height: 200px; object-fit: cover;"
													/>
												</div>
												<div v-if="message.type === 'video'" class="mt-2 mb-2 cursor-pointer" @click="loadVideo(message.id)">
													<div class="flex" v-if="message.file.base64content === undefined">Video.mp4</div>
													<LoadingSpinner :height="30" v-if="videoLoading.state && videoLoading.id === message.id" />
													<video
														controls
														v-if="message.file.base64content !== undefined"
														:src="message.file.base64content"
														style="max-height: 300px"
													></video>
												</div>
												<div v-if="message.type === 'document'" class="flex mt-2 mb-2 cursor-pointer" @click="openFile(message.file)">
													<div class="flex">{{ $t('document') }} {{ message.file.extension }}</div>
													<div class="flex-wrap ml-2">
														<font-awesome-icon :icon="['fas', 'download']" class="pointer-events-none" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style="height: 330px; width: 370px" v-else>
							<LoadingSpinner />
						</div>
					</div>
				</div>
				<div class="flex flex-shrink flex-row justify-end bottom-0 shadow">
					<BaseInput
						ref="BaseInput-message"
						class="flex flex-grow pr-0 w-full pb-0 mb-0"
						style="flex-direction: row;"
						label=""
						aria-multiline="true"
						type="text"
						v-model="newMessage.content"
						:disabled="false"
					>
						<textarea
							:placeholder="getContentHint"
							class="shadow-m h-12 flex resize-none flex-grow"
							style="width: 300px; border-radius: 0; word-break: break-word"
							v-model="newMessage.content"
							@input="tempStoreMessage"
							@keydown.enter.exact.prevent="evaluateSend"
							:disabled="false"
						></textarea>
					</BaseInput>
					<div class="flex flex-shrink">
						<BaseButton
							class="btn-blue"
							:disabled="evaluateDisabled"
							@click="sendMessage"
							style="min-width: 60px!important; min-height: 12px!important; border-radius: 0"
						>
							<font-awesome-icon :icon="['fas', 'chevron-right']" class="text-white" />
						</BaseButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import { ChatsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import { getDamageCaseLabel, getGermanDateTime } from '@/plugins/Utils';
import BaseImage from '@/components/forms/BaseImage.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import CustomerChatMessageRepository from '@/api/repositories/CustomerChatMessageRepository';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'ChatPopup',
	components: {
		LoadingSpinner,
		BaseImage,
		BaseButton,
		BaseInput,
	},
	mixins: [Authentication, AppContainerMixin],
	props: {
		chatId: null,
		customer: null,
		damageCaseId: null,
	},
	data() {
		return {
			messages: [],
			chat: {},
			current_page: 1,
			last_page: 1,
			total: 0,
			per_page: { display: '25', value: 25 },
			isLoading: true,
			isInitialLoading: true,
			contentHint: '',
			messageTimeoutId: null,
			newMessage: {
				type: 'text',
				content: '',
				chat_id: null,
			},
			videoLoading: { state: false, id: '' },
		};
	},
	computed: {
		evaluateDisabled() {
			return this.newMessage.content.length === 0;
		},
		getContentHint() {
			if (this.chat.id) {
				return this.$t('answer');
			}
			if (this.customer.gender === 'company') {
				return `${this.$t('hello')} ${this.customer.companyName}...`;
			} else {
				return `${this.$t('hello')} ${this.customer.firstName} ${this.customer.lastName}...`;
			}
		},
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6) {
			this.isLoading = true;
			if (this.chatId != null) {
				this.chat.id = this.chatId;
			}
			this.getChatInformation(true);
			this.expanded = this.$store.getters.getIsChatExpanded;
		}
	},
	beforeDestroy() {
		clearTimeout(this.messageTimeoutId);
		this.$refs.scrollablelist.removeEventListener('scroll', this.onScroll);
	},
	methods: {
		getGermanDateTime,
		profileImage(image) {
			if (image != null) {
				return image;
			} else {
				return require('../../../../assets/logo.png');
			}
		},
		loadVideo(messageID) {
			this.videoLoading = { state: true, id: messageID };
			new CustomerChatMessageRepository()
				.getChatMedia(messageID)
				.then(response => {
					this.messages.find(element => element.id === messageID).file.base64content = response.data.data.base64content;
					this.videoLoading.state = false;
				})
				.catch(e => {
					console.log(e);
				});
		},
		openFile(content) {
			const blob = new Blob([this.base64ToArrayBuffer(content.base64content.split(',')[1])], { type: 'application/pdf' });
			//TODO: replace with real name
			const name = 'Chat-Datei' + content.extension;
			if (this.isAppContainer) {
				const reader = new FileReader();
				reader.onload = function() {
					const arrayBuffer = this.result;
					// convert the ArrayBuffer to a comma-separated string
					const dataString = new Uint8Array(arrayBuffer).join(',');
					const messageData = {
						fileName: name,
						data: dataString,
					};
					// send the data to Swift
					window.webkit.messageHandlers.pdfHandler.postMessage(JSON.stringify(messageData));
				};
				reader.readAsArrayBuffer(blob);
			} else {
				const resolvingUrl = URL.createObjectURL(blob);
				const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(name)}`;

				setTimeout(function() {
					window.open(viewerUrl, '_blank');
					window.URL.revokeObjectURL(viewerUrl);
				}, 200);
			}
		},
		base64ToArrayBuffer(base64) {
			const binaryString = atob(base64);
			const bytes = new Uint8Array(binaryString.length);
			for (let i = 0; i < binaryString.length; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return bytes.buffer;
		},
		tempStoreMessage() {
			clearTimeout(this.messageTimeoutId);
			this.messageTimeoutId = setTimeout(() => {
				this.$store.commit('setUnfinishedChatMessage', { id: this.damageCaseId, message: this.newMessage.content });
			}, 1000);
		},
		triggerState() {
			this.expanded = !this.expanded;
			this.$emit('changeState', this.expanded);
			this.$store.commit('setIsChatExpanded', this.expanded);
		},
		evaluateSend() {
			if (this.newMessage.content.length > 1) {
				this.sendMessage();
			}
		},
		getChatInformation(getMessagesAfter) {
			if (this.chat.id != null) {
				ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.chatsIdGet(this.chat.id)
					.then(response => {
						this.chat = response.data.data;
						this.subject =
							this.chat.subject === 'general'
								? this.$t('general_title')
								: getDamageCaseLabel(this.chat.damage_case.type, this.chat.damage_case.license_plate, this.chat.damage_case.date_of_accident);
						this.title = `${this.subject} - ${this.chat.customer.first_name} ${this.chat.customer.last_name}`;
						if (getMessagesAfter) {
							this.getMessages();
						} else {
							this.isLoading = false;
						}
					});
			} else {
				this.isInitialLoading = false;
			}
			const storedContent = this.$store.getters.getUnfinishedChatMessage(this.damageCaseId);
			this.newMessage.content = storedContent != null ? storedContent.message : '';
		},
		getMessages() {
			if (this.chat.id != null) {
				this.isLoading = true;
				ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.messagesGet(this.chat.id, this.current_page, this.per_page.value)
					.then(response => {
						this.last_page = response.data.meta.last_page;
						this.current_page = response.data.meta.current_page;
						this.total = response.data.meta.total;
						const newData = response.data.data.reverse();
						if (this.messages.length === 0) {
							this.messages = newData;
							this.$nextTick(() => {
								this.$refs.messagesRef?.lastElementChild.scrollIntoView({ block: 'nearest', inline: 'start' });
							});
						} else {
							newData.forEach(element => {
								this.messages.unshift(element);
							});
						}

						// const itemName = `item_${this.messages.length-1}`
						// console.log(this.$refs.element23)
						// const a = document.getElementById(this.$refs.element23.id);
						// a.scrollTop = a.scrollHeight;

						//	this.$store.dispatch('updateChatsCount');
					})
					.finally(_ => {
						this.isLoading = false;
						if (this.isInitialLoading) {
							this.$refs.scrollablelist.addEventListener('scroll', this.onScroll);
						}
						this.$store.dispatch('updateChatsCount');
						this.isInitialLoading = false;
					})
					// 	.finally(_ => {
					//     this.$nextTick(() => {
					//
					//       //const a = document.getElementById('element25d');
					//       console.log(this.$refs.element25.id)
					//       document.documentElement.scrollTo(0, this.$refs.element25.scrollTop);
					//     });
					//
					// })
					.catch(error => {
						this.isLoading = false;
						console.log(error);
					});
			}
		},
		onScroll(e) {
			if (this.$refs.messagesRef != null && this.$refs.messagesRef?.lastElementChild != null) {
				const elementHeight = this.$refs.messagesRef.lastElementChild.scrollHeight;

				if (this.$refs.scrollablelist.scrollTop <= (elementHeight - 10) * 10 && !this.isLoading && this.total > this.messages.length) {
					this.isLoading = true;
					this.current_page += 1;
					this.getMessages();
				}
			}
		},
		sendMessage() {
			if (!this.evaluateDisabled) {
				this.isLoading = true;
				if (this.chat.id != null) {
					this.newMessage.chat_id = this.chat.id;
					ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.messagesPost(this.newMessage)
						.then(response => {
							clearTimeout(this.messageTimeoutId);
							this.messages = [];
							this.current_page = 1;
							this.newMessage.content = '';
							this.$store.commit('clearUnfinishedMessage', { id: this.damageCaseId });
							this.getMessages();
						});
				} else {
					this.chat.damage_case_id = this.damageCaseId;
					this.chat.receiver_id = this.customer.id;
					this.chat.type = 'text';
					this.chat.content = this.newMessage.content;

					ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.messagesPost(this.chat)
						.then(response => {
							this.chat.id = response.data.data.chat_id;
							this.getChatInformation(true);
							clearTimeout(this.messageTimeoutId);
							this.messages = [];
							this.current_page = 1;
							this.newMessage.content = '';
							this.$store.commit('clearUnfinishedMessage', { id: this.damageCaseId });
						})
						.catch(error => {
							console.log(error);
						});
				}
			}
		},
	},
	watch: {
		'$store.getters.getUnreadChatsCount': function(value) {
			const element = this.$store.getters.getUnreadChatsCount.chats.find(element => element.chat_id === this.chat.id);
			if (element != null) {
				if (element.count !== 0) {
					this.messages = [];
					this.current_page = 1;
					if (value !== 0 && !this.isInitialLoading) {
						this.getMessages();
					}
				}
			}
		},
	},
};
</script>

<style lang="sass" scoped></style>
